import * as React from 'react'
import { ChipField, FunctionField, useRecordContext } from 'react-admin'
import { FC } from 'react'

import { Geo } from 'shared/types'

interface GeoFieldProps {
  link?: boolean
  record?: Geo
}

const GeoField: FC<GeoFieldProps> = ({ children, ...props }) => {
  const record = useRecordContext()
  return (
    <FunctionField
      record={record}
      label="Name"
      render={(record: Geo) => {
        const { kind, country, region, subregion } = record

        let label: string
        switch (kind) {
          case 'country':
            label = country
            break
          case 'state':
            label = region
            break
          default:
            label = subregion
        }

        return <ChipField source="label" {...props} />
      }}
    />
  )
}

export default GeoField
